import React from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import SectionContainer from "./SectionContainer";
import NeonButton from "./NeonButton";
import TypewriterPreview from "./TypewriterPreview";

const HeroSection: React.FC = () => {
  const { t } = useTranslation("home");

  return (
    <SectionContainer className="pt-8 md:pt-16 pb-8">
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
        <motion.div
          className="lg:col-span-3 space-y-6"
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1
            className="text-display md:text-display-xl text-gradient-brand"
            style={{ lineHeight: "125%" }}
          >
            {t("hero_title")}
          </h1>
          <h2 className="text-body-lg text-gray-400 leading-relaxed max-w-2xl">
            {t("hero_subtitle")}
          </h2>
          <NeonButton to="/products" size="lg" breathe ariaLabel={t("hero_cta")}>
            {t("hero_cta")}
          </NeonButton>
        </motion.div>

        <motion.div
          className="lg:col-span-2"
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <TypewriterPreview />
        </motion.div>
      </div>
    </SectionContainer>
  );
};

export default HeroSection;
